<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Urejanje šifrantov</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    <!--
 :
         
    -->
    <div class="telo_vsebine adapt v-adapt">

        <div>
        <div :style="{ display: 'inline-block' }">
            Šifrant
            <br />
            <dropdownlist
                :data-items="sifranti"
                :text-field="'nazivSifranta'"
                @change="sifrantChange"
                :default-item="defaultItemSifrant"
                :value="selectedSifrant"
            />
        </div>
        <div :style="{ display: 'inline-block', marginLeft: '30px' }">
            Sezona
            <br />
            <dropdownlist
                :disabled="!hasSifrant"
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :default-item="defaultItemSezona"
                :value="sezona"
            />
        </div>
    </div>
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>


           <Grid  
                       auto-bind=false
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                            :pageable="{ buttonCount: 4, pageSizes: [10,50,100] }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :group="group" 
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"
                        :expand-field="'expanded'"
                        @expandchange="expandChange"
                        @pagechange="pageChangeHandler"
                       
                        :edit-field="'inEdit'"
                        @edit="edit"
                        @save="saveButton"
                        @insert="insertItem"
                        @cancel="cancel"
                        @itemchange="itemChange"
                        
                       

                     
                        >
                      <template v-slot:myDropDownCell="{props}">
                      <sifrantEnotKolicine :data-item="props.dataItem" 
                        :field="props.field"
                        :sifrantData="sifrant['enotakolicine']"
                        :selectedValue="{id:props.dataItem.enotakolicineid,naziv:props.dataItem.enota}"
                         @change="(e) => sifrantEnotKolicineChange(e, props.dataItem)"
                        />
                    </template>
                    
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                       
                             <button
                                title="Izvozi v excel"
                                class="k-button k-primary"
                                @click="exportExcelAll"
                            >
                                Izvozi v Excel
                            </button>
 <!--
    TODO najvišji nivo!!!
                            <button
                                title="Dodaj najvišji nivo"
                                class="k-button k-primary"
                                @click="dodajElement"
                            >
                                Dodaj najvišji nivo
                            </button>

                        -->
                        </div>
                            
                        </toolbar>
                    </Grid>
        
   
    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import kulture from './support/kulture-data';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import SifrantEnotKolicine from './support/SifrantEnotKolicineDropDown';

import { process } from '@progress/kendo-data-query';

//preberi id-je šifrantov iz baze??
const dataSifranti = [
    { nazivSifranta : "Kulture", sifrantId: "kultura" },
    { nazivSifranta: "Živali", sifrantId: "zival" },
    { nazivSifranta: "Proizvodi", sifrantId: "proizvod" },
   // { nazivSifranta: "Dejavnosti", sifrantId: "dejavnost" },
];


//preberi sezone za šifrante iz baze??


//verjetno v lastno komponento
const CommandCell = Vue.component("template-component", {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String
    },
    computed: {
       
      returnGroupName(){
        if(this.rowType == 'groupHeader'){
            if(this.dataItem.field&&this.dataItem.items.length==1)
                return {    nivoSifranta:this.dataItem.field,
                            idSifranta:this.dataItem.items[0]['id'+this.dataItem.field],
                            nazivSifranta:this.dataItem.items[0][this.dataItem.field]};
                            //plus gumbi za dodajanje kategorij
        }
        else{
            return false;
        }
      },
      renderCell(){
      
        return this.field !== undefined && this.rowType !== 'groupHeader';
      }
    },
    //footer row ima gumb dodaj
    template: ` <td v-if="!dataItem['inEdit']&&renderCell">
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="editHandler">
                        Uredi
                    </button>
                </td>
                <td v-else-if="renderCell||dataItem['inEdit']">
                    
                       <button
                           class="k-button k-grid-save-command"
                           @click="addUpdateHandler">
                           {{dataItem.id? 'Shrani' : 'Dodaj'}}
                       </button>
                       <button
                           class="k-button k-grid-cancel-command"
                           @click="cancelDiscardHandler">
                           {{dataItem.id? 'Prekliči' : 'Prekliči'}}
                       </button>
                   </td>
                <td v-else-if="!renderCell">
                    
                       <button
                           class="k-button k-grid-save-command"
                           @click="addInsertHandler">
                           Dodaj
                       </button>
                       
                   </td>`,
    methods: {
        editHandler: function() {
            this.$emit('edit', {dataItem:this.dataItem});
        },
        addUpdateHandler: function() {
            this.$emit('save', {dataItem:this.dataItem});
        },
        addInsertHandler: function() {
            this.$emit('insert', {dataItem:this.dataItem});
        },
        cancelDiscardHandler: function() {
            this.$emit('cancel', {dataItem:this.dataItem});
        }
    }
});



Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);


export default {
    components:{
    'sifrantEnotKolicine':SifrantEnotKolicine
    },
    data () {
        return {
            defaultItemSezona: { sezona: 'Izberi sezono...'},
            defaultItemSifrant: { nazivSifranta: 'Izberi šifrant...' },
            sezona:null,
            selectedSifrant:null,
         
            sifranti:dataSifranti,

            girdDataApi:null,
            gridData:null,


            filter: null,
            editID: null,
            skip: 0,
            take: 10,
            sortable: true,
            filterable: true,
            groupable:true,
            
            expandedItems: [],
            dataResult: [],
            group:[],sort:[],columns:[]

           

        }
    },
    created () {
      
    },
    computed: {

        ...mapState('sifrant', ['sifrant']),
        ...mapState('users', ['sezonePisanje']),
        
        sifrantData:function(){
            return this.sifrant[this.selectedSifrant.sifrantId];
        },
        hasSifrant: function(){
            return this.selectedSifrant && this.selectedSifrant !== this.defaultItemSifrant;
        }
    },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.sifrantData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.sifrantData, dataState);
        }
        
     
    
},
    methods: {

        ...mapActions('sifrant', ['load','replace','save']),

        sifrantChange(event) {
            if(event.value==this.defaultItemSifrant)
                return;
            
            const sifrant = event.value;
            //const sezone = dataSezone.filter(sezona => sezona.sifrantId === sifrant.sifrantId);
    
            this.selectedSifrant = sifrant;
            //this.sezone = sezone;
            this.sezona = null;
           
        },
        sezonaChange(event) {

            if(event.value==this.defaultItemSezona)
                return;
            

            const sezona = event.value;
            this.sezona=sezona;
          

            if(this.selectedSifrant.sifrantId=="kultura") {
               this.group= [
                { field: 'vrstakulture' },
                { field: 'skupinakulture' }
            ];
            this.sort= [
                { field: 'vrstakulture', dir: 'asc' }
            ];
            this.columns= [
                { field: "vrstakulture", title:"Vrsta kulture",width: "100px",editable:false},
                { field: "skupinakulture", title:"Skupina kulture",width: "100px"},

                { field: "naziv", title:"Kultura",width: "150px"},
                { field: "kategorija", title:"Kat.",width: "50px"},
                { field: "certifikat", title:"Certifikat",width: "150px"},
                { field: "certifikaten", title:"Certifikat EN",width: "100px"},
                { field: "certifikatde", title:"Certifikat DE",width: "100px"},
                { field: "certifikatit", title:"Certifikat IT",width: "100px"},
                { field: "certifikathu", title:"Certifikat HU",width: "100px"},
                { field: "id", title:"Šifra",width: "50px",editable:false},


                { field: "jeaktivna", title:"Aktivna",filterable:false,editor: 'boolean',filter:'boolean',width: "70px",cell:this.booleanIcon },
                { cell: CommandCell, width: '180px',filterable:false }
            ];
            }
            else if (this.selectedSifrant.sifrantId=="zival") {
               this.group= [
                { field: 'vrstazivali' },
                { field: 'skupinazivali' }
            ];
            this.sort= [
                { field: 'vrstazivali', dir: 'asc' },
                { field: 'skupinazivali', dir: 'asc' }
            ];
            this.columns= [
                { field: "vrstazivali", title:"Vrsta zivali", width: "100px",editable:false},
                { field: "skupinazivali", title:"Skupina zivali",width: "100px"},
                { field: "naziv", title:"Žival",width: "150px"},
                { field: "gvz", title:"GVŽ",type: "number",format: '{0:n}',width: "80px"},
                { field: "jepasna", title:"Travojeda",editor: 'boolean',filter:'boolean',width: "100px",cell:this.booleanIcon },
                { field: "kategorija", title:"Kat.",width: "50px"},
                { field: "certifikat", title:"Certifikat",width: "150px"},
                { field: "certifikaten", title:"Certifikat EN",width: "100px"},
                { field: "certifikatde", title:"Certifikat DE",width: "100px"},
                { field: "certifikatit", title:"Certifikat IT",width: "100px"},
                { field: "certifikathu", title:"Certifikat HU",width: "100px"},
                { field: "jeaktivna", title:"Aktivna",editor: 'boolean',filter:'boolean',width: "70px",cell:this.booleanIcon },
                { cell: CommandCell, width: '180px',filterable:false }
            ];
            }
            else if (this.selectedSifrant.sifrantId=="proizvod") {
                this.load({sezona:this.sezona.sezona,sifrant:"enotakolicine"});

               this.group= [
                { field: 'vrstaproizvoda' },
                { field: 'skupinaproizvoda' }
            ];
            this.sort= [
                { field: 'vrstaproizvoda', dir: 'asc' },
                { field: 'skupinaproizvoda', dir: 'asc' }
            ];
            this.columns= [
                { field: "vrstaproizvoda", title:"Vrsta proizvoda", width: "100px",editable:false},
                { field: "skupinaproizvoda", title:"Skupina proizvoda",width: "100px"},
                { field: "naziv", title:"Proizvod",width: "150px"},
                { field: "enota", title:"Enota",width: "100px",cell:'myDropDownCell'},
                //edit cell je sifrant enot kolicine dropdown!!!
                { field: "kategorija", title:"Kat.",width: "50px"},
                { field: "certifikat", title:"Certifikat",width: "150px"},
                { field: "certifikaten", title:"Certifikat EN",width: "100px"},
                { field: "certifikatde", title:"Certifikat DE",width: "100px"},
                { field: "certifikatit", title:"Certifikat IT",width: "100px"},
                { field: "certifikathu", title:"Certifikat HU",width: "100px"},
                { field: "id", title:"Šifra",width: "50px",editable:false},
                { field: "jeaktivna", title:"Aktivna",editor: 'boolean',filter:'boolean',width: "70px",cell:this.booleanIcon },
                { cell: CommandCell, width: '180px',filterable:false }
            ];
            }
            else if (this.selectedSifrant.sifrantId=="dejavnost") {
                this.load({sezona:this.sezona.sezona,sifrant:"enotakolicine"});

               this.group= [
                { field: 'vrstadejavnosti' },
                { field: 'skupinadejavnosti' }
            ];
            this.sort= [
                { field: 'vrstadejavnosti', dir: 'asc' },
                { field: 'skupinadejavnosti', dir: 'asc' }
            ];
            this.columns= [
                { field: "vrstadejavnosti", title:"Vrsta dejavnosti", width: "100px"},
                { field: "skupinadejavnosti", title:"Skupina dejavnosti",width: "200px"},
                { field: "naziv", title:"Dejavnost",width: "200px"},
                { field: "enota", title:"Enota",width: "100px",cell:'myDropDownCell'},
                //edit cell je sifrant enot kolicine dropdown!!!
                { field: "jeaktivna", title:"Aktivna",editor: 'boolean',filter:'boolean',width: "100px",cell:this.booleanIcon },
                { cell: CommandCell, width: '180px',filterable:false }
            ];
            }

             this.load({sifrant:this.selectedSifrant.sifrantId,sezona:sezona.sezona}).then(()=>{

                      let sifrant=this.sifrant[this.selectedSifrant.sifrantId];
                
               
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
                };
                this.dataResult = process( sifrant, dataState);
             });



        },

         booleanIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;
            if(props.field !== undefined && props.rowType !== 'groupHeader'){
            let pisanje=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem[props.field])
                pisanje=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let pisanjeWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem[props.field],"action_success":props.dataItem[props.field]}}, [pisanje]);
            return h('td', {attrs:{colspan:1}}, [pisanjeWrapper]);
            }
        },

         sifrantEnotKolicineChange: function(e, dataItem) {


             if(!dataItem.newValues)
                dataItem.newValues={};
            

                
              dataItem.newValues["enotakolicineid"] =e.value.id;
              dataItem.newValues["enota"] =e.value.naziv;

            
    
        },
       
        
        
        createAppState: function(dataState) {
           
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            if (dataState.group) {
                dataState.group.map(group => group.aggregates = this.aggregates);
            }
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
          
            this.createAppState(event.data);
            this.dataResult = process(this.sifrantData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
         

        },
        expandChange (event) {
            const isExpanded =
                event.dataItem.expanded === undefined ?
                    event.dataItem.aggregates : event.dataItem.expanded;
            Vue.set(event.dataItem, 'expanded', !isExpanded);
           
        },
 

        exportExcelAll () {
            saveExcel({
                data: process(this.sifrantData, {
                
                sort: this.sort,
                filter: this.filter,
                
            }).data,
                fileName: this.selectedSifrant.sifrantId+"_"+this.sezona.sezona,
                columns: this.columns
            });
        },
        
        itemChange: function (e) {
          
            if(!e.dataItem.newValues)
                e.dataItem.newValues={};
            

            if(e.value===false)
                e.dataItem.newValues[e.field]=0;
            else if (e.value===true)
                e.dataItem.newValues[e.field]=1;
            else
                e.dataItem.newValues[e.field]=e.value;


        },
        dodajElement: function(event) {

                //glede na sifrant, pripravi nov zapis
                //this.sifrantData[0]
                //spucaj vrednosti
                //daj inedut
                //var newItem=JSON.parse(JSON.stringify(this.sifrantData[0]));
                //newItem.inEdit=true;
                //newItem.id=0;
                //this.insert({sifrantItem: newItem,sifrant:this.selectedSifrant.sifrantId,sezona:this.sezona.sezona})
                //nov gui, sub komponenta vnesi podatke o novem elementu
                //dodaj plus gumbe na prava mesta...

            
            
    
        },
        edit: function (e) {
             
            Vue.set(e.dataItem, 'inEdit', true);
           // console.log(e.dataItem);
        },
        insertItem: function(e) {
            
           /*   for (var field in e.dataItem.newValues){
            
                 e.dataItem[field]=e.dataItem.newValues[field];
                 }*/
            //poglej, če lahko greš dva nivoja dol...
            //če ja, prvič vstavi eno (na začetek,in potem še eno, na začetek)
            var items=e.dataItem.items;
            var subitems=e.dataItem.items;
            var newItem;
            if(items.length>0&&items[0].items){
                   console.log("kliknil 1.nivo");
                   //izberi prvi subitem
                   subitems=items[0].items;
                   
                   var firstItem=JSON.parse(JSON.stringify(items[0]));
                   firstItem.value="Nov element";
                   firstItem.items=[];
                   //subitems=firstItem.items;
                   items.unshift(firstItem);
                     newItem=JSON.parse(JSON.stringify(subitems[0]));
                     //vsi id-ji na 0 vsi stringi na "nov element"
                   firstItem.items.unshift(newItem);
                   for (const property in newItem) {
                    if(property.indexOf("skupina")>=0||property.indexOf("naziv")>=0)
                            newItem[property]="Nov element";
                    if(property.indexOf("idskupina")>=0||property=="id")
                        newItem[property]=0;

                        console.log(`${property}: ${newItem[property]}`);
                    }
                 Vue.set(newItem, 'inEdit', true);
                   //dol nastavi vse nove vrednosti...



                   //unshift na prvo mesto, pa subitem enega od spodaj...
            } //dodajamo na vrhnjem nivoju
            else if(subitems.length>=0) {
                console.log("obstaja 2.nivo");
                 newItem=JSON.parse(JSON.stringify(subitems[0]));
                   subitems.unshift(newItem);
                   newItem.naziv="";
                   newItem.id=0;
                    Vue.set(newItem, 'inEdit', true);
            }
            
            //prazno, zadnaj je z inedit
            //e.dataItem.items.push(e.dataItem.items[0])
           //Vue.set(e.dataItem, 'inEdit', undefined);
           

           
        },



        saveButton: function(e) {
            
              for (var field in e.dataItem.newValues){
            
                 e.dataItem[field]=e.dataItem.newValues[field];
                 }
           Vue.set(e.dataItem, 'inEdit', undefined);
           var thisComp=this;
           this.save({sifrantItem: e.dataItem,sifrant:this.selectedSifrant.sifrantId,sezona:this.sezona.sezona})
           .then(()=>{
           thisComp.dataResult = process(thisComp.sifrantData, {
                skip: thisComp.skip,
                take: thisComp.take,
                sort: thisComp.sort,
                filter: thisComp.filter,
                group: thisComp.group
            }); 
           })
           
        },
        cancel(e) {
             
            if (e.dataItem.id) {
                
               
                 Vue.set(e.dataItem, 'inEdit', undefined);
            } else {
             
            }
        },
        
         pageChangeHandler: function(event) {
          
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>
